// https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client
// Bundled into the client runtime and executed before hydration on every page
// load — including client-side-render bailout pages, which omit the root
// layout's <head>. Keep this module tiny and side-effect-only.
import { normalizeLocationPathSlashes } from '@/lib/urlUtils'

normalizeLocationPathSlashes()
